// 此文件不要动
export const nameComponentObj = {
  "layout": {
    name: "layout",
    label: "父级组件",
    component: () => import(/* webpackChunkName: "layoutModule" */"@/layout")
  },
  "dashboard": {
    path: "/dashboard",
    fullPath: "/dashboard", // tag-views 上有用
    name: "dashboard",
    meta: {
      title: "首页", //meta里面也要有title 用于面包屑上使用
      affix: true,
      showFooter: true,
      icon: "home"
    },
    component: () => import(/* webpackChunkName: "constantModule" */"@/views/dashboard")
  },
  "notFound": {
    name: "notFound",
    label: "404",
    component: () => import(/* webpackChunkName: "constantModule" */ "@/views/error-module/index")
  }
}

// 没有按钮权限标识数据 也要暴露一个对象出去
export const btnObj = {}